// After a deploy, Vite emits new content-hashed chunk
// filenames and deletes the old ones. A browser still running
// the previous build can try to dynamic-import a page chunk
// whose hash no longer exists; the import throws and navigation
// silently dies until a manual hard refresh.
//
// Inertia's asset versioning (`config.version` on the server)
// already forces a clean full reload on the next *visit* by
// replying 409, but a chunk preload can fail before that
// round-trip resolves. This is the belt-and-suspenders: when a
// dynamic import fails, reload once to pull the fresh build.

const RELOAD_TIMESTAMP_KEY = "vitePreloadErrorReloadedAt"

// If the freshly deployed build is itself unreachable, reloading
// again would loop forever. Only force a reload if we haven't
// already done so within this window — otherwise let the error
// surface instead of looping.
const RELOAD_DEBOUNCE_MS = 10_000

export function installPreloadErrorReload(
  target: Window = window,
  storage: Storage = window.sessionStorage,
) {
  target.addEventListener("vite:preloadError", (event) => {
    const last = Number(storage.getItem(RELOAD_TIMESTAMP_KEY) ?? 0)

    if (Date.now() - last < RELOAD_DEBOUNCE_MS) return

    event.preventDefault()
    storage.setItem(RELOAD_TIMESTAMP_KEY, String(Date.now()))
    target.location.reload()
  })
}
